import { Button, IconButton, Box, Grid, Card, CardContent, Typography, Breadcrumbs, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import WebOutlinedIcon from "@mui/icons-material/WebOutlined";
import MoreVertIcon from '@mui/icons-material/MoreVert';

const ViewCollection = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    // Mock data for the specific collection
    const collection = {
        id: id || 1,
        name: "Summer Collection 2025",
        description: "Hot products for summer season. This collection features lightweight fabrics, vibrant colors, and trendy designs perfect for the heat.",
        products: 24,
        featured: true,
        type: "Seasonal",
        reason: "Campaign • May - Aug",
        status: "Active",
        metadata: { startDate: "2025-05-01", endDate: "2025-08-31", timezone: "GST" },
        surfaces: ["Homepage", "App"],
        performance: { views: "12.5K", revenue: "AED 45K", ctr: "4.2%" }
    };

    const productList = [
        { id: 101, name: "Floral Summer Dress", sku: "SUM-001", price: "AED 299", stock: 45, category: "Women's Clothing" },
        { id: 102, name: "Beach Straw Hat", sku: "SUM-002", price: "AED 89", stock: 120, category: "Accessories" },
        { id: 103, name: "Men's Linen Shirt", sku: "SUM-003", price: "AED 180", stock: 30, category: "Men's Clothing" },
        { id: 104, name: "Designer Sunglasses", sku: "SUM-004", price: "AED 450", stock: 15, category: "Accessories" },
        { id: 105, name: "Casual Flip Flops", sku: "SUM-005", price: "AED 50", stock: 200, category: "Footwear" },
    ];

    return (
        <div className="view_collection_page">
            <div className="main_title" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <IconButton onClick={() => navigate("/manage-collections")} sx={{ color: '#000' }}>
                    <ArrowBackIcon />
                </IconButton>
                <div>
                    <h1>Collection Details</h1>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: '14px' }}>
                        <Link underline="hover" color="inherit" onClick={() => navigate("/dashboard")} sx={{ cursor: 'pointer' }}>
                            Dashboard
                        </Link>
                        <Link underline="hover" color="inherit" onClick={() => navigate("/manage-collections")} sx={{ cursor: 'pointer' }}>
                            Manage Collections
                        </Link>
                        <Typography color="text.primary">View Collection</Typography>
                    </Breadcrumbs>
                </div>
            </div>

            <Grid container spacing={3} sx={{ mt: 1 }}>
                <Grid item xs={12} md={4}>
                    <Card sx={{ borderRadius: '12px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <FolderOutlinedIcon color="primary" />
                                    <Typography variant="h6" fontWeight={700}>{collection.name}</Typography>
                                </Box>
                                <span className={`badge1 ${collection.status.toLowerCase()}`}>{collection.status}</span>
                            </Box>

                            <Typography color="text.secondary" variant="body2" sx={{ mb: 2 }}>
                                {collection.description}
                            </Typography>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary" variant="body2">Type</Typography>
                                    <Typography variant="body2" fontWeight={600}>{collection.type}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary" variant="body2">Featured</Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        {collection.featured ? <StarRoundedIcon sx={{ color: '#FFD700', fontSize: 18 }} /> : 'No'}
                                        <Typography variant="body2" fontWeight={600}>{collection.featured ? 'Yes' : ''}</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary" variant="body2">Validity</Typography>
                                    <Typography variant="body2" fontWeight={600}>
                                        {collection.metadata.startDate} to {collection.metadata.endDate}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary" variant="body2">Surfaces</Typography>
                                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                                        {collection.surfaces.map((s, idx) => (
                                            <Box key={idx} sx={{ color: '#c49133' }} title={s}>
                                                {s === 'Homepage' && <HomeOutlinedIcon sx={{ fontSize: 18 }} />}
                                                {s === 'App' && <PhoneAndroidOutlinedIcon sx={{ fontSize: 18 }} />}
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>

                            <Box sx={{ mt: 3, p: 2, bgcolor: '#f9f9f9', borderRadius: '8px' }}>
                                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>Performance Summary</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography variant="caption" color="text.secondary">Views</Typography>
                                        <Typography variant="body2" fontWeight={600}>{collection.performance.views}</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="caption" color="text.secondary">Revenue</Typography>
                                        <Typography variant="body2" fontWeight={600}>{collection.performance.revenue}</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="caption" color="text.secondary">CTR</Typography>
                                        <Typography variant="body2" fontWeight={600}>{collection.performance.ctr}</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={8}>
                    <Card sx={{ borderRadius: '12px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h6" fontWeight={700}>Products in Collection ({collection.products})</Typography>
                              
                            </Box>

                            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #f0f0f0' }}>
                                <Table>
                                    <TableHead sx={{ bgcolor: '#fcfcfc' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 600 }}>Product Name</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>SKU</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Price</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Stock</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {productList.map((row) => (
                                            <TableRow key={row.id}>
                                                <TableCell>{row.name}</TableCell>
                                                <TableCell>{row.sku}</TableCell>
                                                <TableCell>{row.category}</TableCell>
                                                <TableCell>{row.price}</TableCell>
                                                <TableCell>{row.stock}</TableCell>
                                                <TableCell>
                                                    <IconButton size="small">
                                                        <MoreVertIcon sx={{ fontSize: 18 }} />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default ViewCollection;
